import { createEntityAdapter, createSlice } from "@reduxjs/toolkit";

import { getClipVideosByStream } from "./actions";

export const clipVideosListEntityAdapter = createEntityAdapter({
  selectId: (entity) => entity._id,
});

const initialState = clipVideosListEntityAdapter.getInitialState({
  totalCount: 0,
  selectedClipVideos: [],
  selectedClipVideosDetails: [],
  modals: {},
  eventIds: [],
});

export const clipVideosListSlice = createSlice({
  name: "clipVideosList",
  initialState: initialState,
  reducers: {
    setSelectedClipVideos: (state, action) => {
      state.selectedClipVideos = action.payload;
    },
    addSelectedClipVideos: (state, action) => {
      state.selectedClipVideos = Array.from(new Set([...state.selectedClipVideos.concat(action.payload)]));
    },
    removeSelectedClipVideos: (state, action) => {
      state.selectedClipVideos = state.selectedClipVideos.filter(
        (clipVideoId) => !action.payload.includes(clipVideoId),
      );
    },
    addSelectedClipVideosDetails: (state, action) => {
      const toAdd = action.payload;
      const exists = state.selectedClipVideosDetails.some((item) => item.contentId === toAdd.contentId);
      if (!exists) {
        state.selectedClipVideosDetails = [...state.selectedClipVideosDetails, toAdd];
      }
    },
    removeSelectedClipVideosDetails: (state, action) => {
      const toRemove = action.payload;

      state.selectedClipVideosDetails = state.selectedClipVideosDetails.filter(
        (item) => !(item.contentId === toRemove.contentId),
      );
    },

    setSelectedClipVideosDetails: (state, action) => {
      state.selectedClipVideosDetails = action.payload;
    },

    showClipVideoBulkDeleteModal: (state, action) => {
      state.modals.clipVideoBulkDeleteModal = action.payload;
    },
    showClipVideoBulkDownloadModal: (state, action) => {
      state.modals.clipVideoBulkDownloadModal = action.payload;
    },
    storeEventId: (state, action) => {
      state.eventIds.push(action.payload);
    },
    removeClipVideoEventId: (state, action) => {
      state.eventIds = state.eventIds.filter((id) => id !== action.payload);
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getClipVideosByStream.fulfilled, (state, action) => {
      if (action.payload.success) {
        clipVideosListEntityAdapter.setAll(state, action.payload.data);
        state.totalCount = action.payload.totalCounts;
      }
    });
  },
});

export const {
  setSelectedClipVideos,
  addSelectedClipVideos,
  removeSelectedClipVideos,
  showClipVideoBulkDeleteModal,
  showClipVideoBulkDownloadModal,
  storeEventId,
  removeClipVideoEventId,
  addSelectedClipVideosDetails,
  removeSelectedClipVideosDetails,
  setSelectedClipVideosDetails,
} = clipVideosListSlice.actions;

export default clipVideosListSlice.reducer;
